import { IsEmail } from "class-validator";

export class EmailInput {
  @IsEmail(undefined, { message: "Email address is not valid" })
  public email: string;
}
